export const loadResponsivePositions = () => {
  document.querySelectorAll('.responsive-position').forEach((div) => {
    new ResponsivePosition(div);
  });
};

class ResponsivePosition {
  constructor(div) {
    this.originalPos = div.parentElement;
    this.currentPos = this.originalPos;
    this.content = this.originalPos.firstChild;

    this.breakpoints = JSON.parse(div.dataset.responsivePositions);
    this.update();
    window.addEventListener('resize', this.update);
  }

  update = () => {
    const screenWidth = window.innerWidth;

    let newPos;
    for (const bp of this.breakpoints) {
      if (bp.width > screenWidth) newPos = document.getElementById(bp.id);
    }
    this.move(newPos);
  };

  move = (newPos) => {
    if (newPos === this.currentPos) return;
    if (newPos === undefined || newPos === null) newPos = this.originalPos;

    newPos.appendChild(this.content);
    this.currentPos = newPos;
  };
}
